import styled from 'styled-components';

const s = {
  Divider: styled.div`
    width: 1px;
    height: 8px;
    background-color: rgba(255, 255, 255, 0.5);
  `,
  footerContainer: styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 16px;
    background-color: #3c3c3c;
    gap: 24px;
    font-family: Spoqa Han Sans Neo;
  `,

  footerTitleBox: styled.div`
    width: 100%;
  `,

  titleSpan: styled.span`
    color: #ffffff;
    letter-spacing: -1%;
  `,

  titleLine: styled.div`
    height: 14px;
    border-right: 1px solid;
    border-right-color: #ffffffa3;
  `,

  infoContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,

  companyInfo: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    font-family: Spoqa Han Sans Neo;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  `,

  infoText: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-family: Spoqa Han Sans Neo;
    font-size: 12px;
    font-weight: 500;
    line-height: 17.4px;
    letter-spacing: -0.6px;
    color: rgba(255, 255, 255, 0.78);
  `,

  EmailContainer: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.52);
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  EmailBox: styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    padding: 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    z-index: 100;
  `,

  EmailInner: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 6px;
    width: 100%;

    color: #616161;
    font-size: 16px;
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    line-height: 23.2px;
    word-wrap: break-word;

    span {
      color: #222222;
      font-size: 18px;
      font-family: Spoqa Han Sans Neo;
      font-weight: 700;
      line-height: 26.1px;
      word-wrap: break-word;
    }
  `,

  ButtonBox: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 28px;
    background-color: #008aff;
    border-radius: 8px;
    color: white;
    font-size: 16px;
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    line-height: 26.4px;
    word-wrap: break-word;
    cursor: pointer;
  `,
};

export default s;
